import { $ } from '@/libs/jquery/index'
import { PopUps } from '@/utilities/popups'

export class RackAttackHelper {
  constructor() {
    this.init()
  }

  public init(): void {
    $( document ).ajaxError((e, xhr, settings, thrownError) => {
      if (xhr.getResponseHeader('X-RateLimit-Limit')) {
        PopUps.showPopupByContent({
          textContent: `<div class='popups--transparent'>
              <div class='popups__title--medium'>Вы превысили допустимый лимит попыток.</div>
            </div>`,
        })
      }
    })
  }
}
